export const environment = {
  apiKey: 'd4a7babc930bc6a1b8bb62810f51cda0'
};